// extracted by mini-css-extract-plugin
export default {"root":"CallButton_root__7068Z","icon":"CallButton_icon__TdnSh"};